import { DirectoryGroupingConsts, ItemTypeConsts } from 'client/util/Constants';
import ActiveDirectoryApi from 'client/api/v2/ActiveDirectoryApi';
import IdsourceApi from 'client/api/v2/IdsourceApi';
import createModel from 'client/store/modules/models/createModel';

const { memberTypes } = DirectoryGroupingConsts;

export const getDefaultItem = () => ({
  id: '',
  domain: '',
  groupsEnabled: false,
  numberOfImportAgents: 0,
});

const model = createModel(getDefaultItem, 'id', ActiveDirectoryApi);

export default {
  namespaced: true,

  state: {
    ...model.state,
  },

  actions: {
    ...model.actions,

    async fetchItem(context) {
      const { commit, getters = {} } = context;
      const { id } = getters;

      const item = await model.actions.fetchItem(context);

      if (!id || !item) {
        return undefined;
      }

      return IdsourceApi
        .fetchTotalCount(item.domain)
        .then((numberOfImportAgents) => {
          const payload = { numberOfImportAgents };
          commit('SET_ITEM', payload);
          commit('SET_PREVIOUS_ITEM', payload);
        });
    },

    bindAdDomainToUsers(context) {
      return context.dispatch('bindAssociations', {
        parentType: memberTypes.activeDirectory,
        targetType: memberTypes.user,
      });
    },
  },

  getters: {
    ...model.getters,

    displayName(state = { item: {} }) {
      return state.item.domain || undefined;
    },

    haveAssociationsChanged(state, getters) {
      return model.getters.haveAssociationsChanged(state, getters)([ItemTypeConsts.systemUser]);
    },
  },

  mutations: {
    ...model.mutations,
  },
};
